import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import { useContext, useState, Fragment } from "react";
import { DataContext } from "../../context/data-context";
import LoadingSpinner from "../UI/LoadingSpinner";
import { AuthContext } from "../../context/auth-context";
import { addCoupon } from "../../api/add";
import { useNavigate } from "react-router-dom";

export default function AddCoupon() {
  const { user } = useContext(AuthContext);
  const { customers, fetchCoupons } = useContext(DataContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState(false);

  const addCouponHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = {
        code: e.target["Coupon Code"].value,
        type: e.target["Type"].value.toLowerCase(),
        amount: e.target["Amount"].value,
        reusable: e.target["Reusable"].value === "Yes",
        forId:
          e.target["For"].value === "false" ? false : e.target["For"].value,
      };
      const response = await addCoupon(user, payload);
      fetchCoupons(() => {
        navigate("/coupons/info?id=" + response.id);
        setLoading(false);
      });
      setLoading(false);
    } catch (err) {
      console.log(err);
      setWarning(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <Heading
        title="Add Coupon"
        text="Coupons can be used by anyone unless a customer is specified. 
        If you do not want the coupon to be used again, uncheck reusable."
      />

      <form onSubmit={addCouponHandler} className="grid gap-4">
        <div className="info">
          <DetailPair label="Coupon Code" edit={true} />
          <SelectPair
            options={["Percentage", "Fixed"]}
            label="Type"
            edit={true}
          />
          <DetailPair label="Amount" edit={true} />
          <SelectPair options={["No", "Yes"]} label="Reusable" edit={true} />
          <SelectPair
            options={[
              { id: false, name: "Everyone" },
              ...customers.map((c) => ({
                id: c.id,
                name: `${c.firstName} ${c.lastName}`,
              })),
            ]}
            label="For"
            edit={true}
          />
        </div>
        <div className="items-end info">
          {loading ? (
            <LoadingSpinner />
          ) : (
            <Fragment>
              <button className="btn-primary md:w-fit">Confirm</button>
              <p className="text-red-700">{warning}</p>
            </Fragment>
          )}
        </div>
      </form>
    </div>
  );
}
